import { useRef } from 'react';

interface EmptySearchResultProps {
  type: 'image' | 'text';
  onBack: () => void;
  onImageUpload?: (file: File) => void;
}

export default function EmptySearchResult({ type, onBack, onImageUpload }: EmptySearchResultProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const isImageSearch = type === 'image';

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onImageUpload) onImageUpload(file);
    event.target.value = '';
  };

  return (
    <section className="rounded-[24px] border border-border bg-white px-6 py-14 text-center shadow-panel">
      {isImageSearch && onImageUpload && (
        <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" />
      )}
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-background-secondary text-secondary-light">
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={isImageSearch ? 'M4 16l4.6-4.6a2 2 0 0 1 2.8 0L16 16m-2-2 1.6-1.6a2 2 0 0 1 2.8 0L20 14M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z' : 'm21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z'} />
        </svg>
      </div>
      <p className="eyebrow mt-5 text-secondary-light">No identity resolved</p>
      <h2 className="mt-2 text-2xl font-semibold tracking-[-0.04em] text-primary">We could not match that card yet</h2>
      <p className="mx-auto mt-3 max-w-lg text-sm leading-6 text-secondary">
        {isImageSearch
          ? 'Try a sharper image with the full artwork or printed number visible. A screenshot or close crop can also help.'
          : 'Try a printed number, another language, or an image. Marketplace listing names often differ for the same card.'}
      </p>
      <div className="mt-7 flex flex-col justify-center gap-2 sm:flex-row">
        <button onClick={onBack} className="rounded-xl border border-border bg-white px-5 py-2.5 text-sm font-semibold text-primary hover:bg-background-secondary">Reset search</button>
        {isImageSearch && onImageUpload && (
          <button onClick={() => fileInputRef.current?.click()} className="rounded-xl bg-ink px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate">Try another image</button>
        )}
      </div>
    </section>
  );
}
